"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connector1CService_UpdateOrdersStatus_Request = exports.Connector1CService_UpdateOrderStatusToIssuedToCustomer_Request = exports.Connector1CService_UpdateOrderProducts_Request = exports.Connector1CService_UpdateDirectory_Request = exports.Connector1CService_UpdateAllRemainders_Request = exports.Connector1CService_QueryOrdersExternal_Request = exports.Complaint = exports.CategoryExt = exports.Category = exports.BusinessService_UpdateOrdersStatus_Request = exports.BusinessService_UpdateOrderStatusToIssuedToCustomer_Request = exports.BusinessService_UpdateOrderProducts_Request = exports.BusinessService_UpdateAllRemainders_Request = exports.BusinessService_QueryOrdersExternal_Request = exports.BusinessService_FilterInStock_Request = exports.BusinessService_CreateOrder_Request = exports.BusinessService_CancelOrderByCustomer_Request = exports.BusinessService_AwaitOrderPaymentPendingLP_Request = exports.BusinessService_AwaitOrderConfirmMasterSystemLP_Request = exports.BrandExt = exports.Brand = exports.Authenticator = exports.AuthService_TryChangePhone_Request = exports.AuthService_TryAuthByPhone_Request = exports.AuthService_ConfirmAuthCode_Request = exports.AuthService_CheckAuthOrEmpty_Request = exports.ArticlesStatus = exports.ArticlesService_UpdateSale_Request = exports.ArticlesService_UpdateNews_Request = exports.ArticlesService_UpdateInfo_Request = exports.ArticlesService_SetPublished_Request = exports.ArticlesService_Archive_Request = exports.ArticleSale = exports.ArticleNews = exports.ArticleInfo = exports.Access = exports.VATCodeEnum = exports.TradeAgentSignEnum = exports.PromoTypeEnum = exports.ProductAttributeTypeEnum = exports.OrderStatusEnum = exports.OrderPaymentTypeEnum = exports.OrderPaymentStatusEnum = exports.OrderDiscountStatusEnum = exports.OrderDeliveryTypeEnum = exports.FileTypeEnum = exports.ComplaintTypeEnum = exports.AuthTypeEnum = exports.ArticleTypeEnum = exports.AccessTypeEnum = void 0;
exports.Product = exports.OrdersPairExt = exports.OrderUpdateStatusExt = exports.OrderUpdateProductsExt = exports.OrderProductExt = exports.OrderProduct = exports.OrderPaymentExt = exports.OrderPaymentDetailsExt = exports.OrderPaymentDetails = exports.OrderPayment = exports.OrderInvoiceItem = exports.OrderInvoice = exports.OrderExt = exports.OrderDiscountRequest = exports.OrderDiscount = exports.OrderDeliveryExt = exports.OrderDelivery = exports.OrderCustomerExt = exports.OrderCustomer = exports.Order = exports.OkResult = exports.NBResult = exports.Message = exports.LoyaltyService_SetPromoCompanyActive_Request = exports.LoyaltyService_RequestOrderDiscount_Request = exports.LoyaltyService_ProcessOrderDiscount_Request = exports.LoyaltyService_CreatePromoCompany_Request = exports.LoyaltyService_AchivePromoCompany_Request = exports.KeywordPair = exports.HeadHuntService_UpdateWorkOffer_Request = exports.HeadHuntService_SetPublished_Request = exports.HeadHuntService_ProcessWorkOfferResponse_Request = exports.HeadHuntService_PostWorkOfferResponse_Request = exports.FilesDirectoryService_ReserveUploadFiles_Request = exports.FilesDirectoryService_QueryReservedFile_Request = exports.FileUploadReserve = exports.FileRecordExt = exports.FileRecord = exports.FileDescriptor = exports.FeedPackage = exports.FavoriteService_UnsetFavoriteProduct_Request = exports.FavoriteService_SubsetFavoriteProductsFromList_Request = exports.FavoriteService_SetFavoriteProduct_Request = exports.DirectoryService_UpdateDirectory_Request = exports.DirectoryService_SortProductsIdsByPrice_Request = exports.DirectoryService_QueryProducts_Request = exports.DirectoryService_QueryProductsIdsByCategories_Request = exports.DeliveryService_SearchDeliveryInfo_Request = exports.DeliveryInfo = exports.Coordinates = void 0;
exports.WorkOfferResponse = exports.WorkOffer = exports.Volume = exports.User = exports.UpdateRemaindersPackExt = exports.UpdateDataPackExt = exports.TradeAgent = exports.TariffsBook = exports.TariffZone = exports.TariffNet = exports.Tariff = exports.SupportService_CreateRequest_Request = exports.SupportService_CloseRequest_Request = exports.SupportRequest = exports.SearchService_SetTypos_Request = exports.SearchService_SetSynonyms_Request = exports.SearchService_SetMisspellings_Request = exports.SearchService_SearchProductsIds_Request = exports.SearchService_Feed_Request = exports.ReviewsService_ReactOnReview_Request = exports.ReviewsService_ReactOnMessage_Request = exports.ReviewsService_ProcessComplaint_Request = exports.ReviewsService_PostReview_Request = exports.ReviewsService_PostMessage_Request = exports.ReviewsService_DeleteReview_Request = exports.ReviewsService_DeleteMessage_Request = exports.ReviewsService_Complaint_Request = exports.Review = exports.ResultPack1C = exports.RemainderExt = exports.QueryFilter = exports.PromoCompany = exports.ProfilesService_UnsetUserAccess_Request = exports.ProfilesService_SetUserData_Request = exports.ProfilesService_SetUserAllAccesses_Request = exports.ProfilesService_SetUserAccess_Request = exports.ProfilesService_SearchUsers_Request = exports.ProfilesService_SearchUsersByAccesses_Request = exports.ProfilesService_DeleteUser_Request = exports.ProfilesService_CreateUserByPhone_Request = exports.ProfilesService_ChangeUserPhone_Request = exports.ProfilesService_ChangeUserEmail_Request = exports.ProductReport = exports.ProductExt = exports.ProductDiscount = exports.ProductAttributeTypeExt = exports.ProductAttributeType = exports.ProductAttributeExt = exports.ProductAttribute = void 0;
const net = require("@ivanlog/net");
var AccessTypeEnum;
(function (AccessTypeEnum) {
    AccessTypeEnum[AccessTypeEnum["Unknown"] = 0] = "Unknown";
    AccessTypeEnum[AccessTypeEnum["ArticlesControl"] = 100] = "ArticlesControl";
    AccessTypeEnum[AccessTypeEnum["UsersControl"] = 101] = "UsersControl";
    AccessTypeEnum[AccessTypeEnum["SupportControl"] = 102] = "SupportControl";
    AccessTypeEnum[AccessTypeEnum["HeadHuntControl"] = 103] = "HeadHuntControl";
    AccessTypeEnum[AccessTypeEnum["FavoritesView"] = 104] = "FavoritesView";
    AccessTypeEnum[AccessTypeEnum["LoyaltyControl"] = 105] = "LoyaltyControl";
    AccessTypeEnum[AccessTypeEnum["LoyaltyProcessing"] = 106] = "LoyaltyProcessing";
    AccessTypeEnum[AccessTypeEnum["SuperAdmin"] = 255] = "SuperAdmin";
})(AccessTypeEnum = exports.AccessTypeEnum || (exports.AccessTypeEnum = {}));
var ArticleTypeEnum;
(function (ArticleTypeEnum) {
    ArticleTypeEnum[ArticleTypeEnum["Unknown"] = 0] = "Unknown";
    ArticleTypeEnum[ArticleTypeEnum["Info"] = 1] = "Info";
    ArticleTypeEnum[ArticleTypeEnum["News"] = 2] = "News";
    ArticleTypeEnum[ArticleTypeEnum["Sale"] = 3] = "Sale";
})(ArticleTypeEnum = exports.ArticleTypeEnum || (exports.ArticleTypeEnum = {}));
var AuthTypeEnum;
(function (AuthTypeEnum) {
    AuthTypeEnum[AuthTypeEnum["Phone"] = 1] = "Phone";
    AuthTypeEnum[AuthTypeEnum["Email"] = 2] = "Email";
})(AuthTypeEnum = exports.AuthTypeEnum || (exports.AuthTypeEnum = {}));
var ComplaintTypeEnum;
(function (ComplaintTypeEnum) {
    ComplaintTypeEnum[ComplaintTypeEnum["Unknown"] = 0] = "Unknown";
    ComplaintTypeEnum[ComplaintTypeEnum["Review"] = 1] = "Review";
    ComplaintTypeEnum[ComplaintTypeEnum["Message"] = 2] = "Message";
})(ComplaintTypeEnum = exports.ComplaintTypeEnum || (exports.ComplaintTypeEnum = {}));
var FileTypeEnum;
(function (FileTypeEnum) {
    FileTypeEnum[FileTypeEnum["Unknown"] = 0] = "Unknown";
    FileTypeEnum[FileTypeEnum["Image"] = 1] = "Image";
    FileTypeEnum[FileTypeEnum["Sound"] = 2] = "Sound";
})(FileTypeEnum = exports.FileTypeEnum || (exports.FileTypeEnum = {}));
var OrderDeliveryTypeEnum;
(function (OrderDeliveryTypeEnum) {
    OrderDeliveryTypeEnum[OrderDeliveryTypeEnum["Unknown"] = 0] = "Unknown";
    OrderDeliveryTypeEnum[OrderDeliveryTypeEnum["SelfPickup"] = 1] = "SelfPickup";
    OrderDeliveryTypeEnum[OrderDeliveryTypeEnum["LocalDelivery"] = 10] = "LocalDelivery";
})(OrderDeliveryTypeEnum = exports.OrderDeliveryTypeEnum || (exports.OrderDeliveryTypeEnum = {}));
var OrderDiscountStatusEnum;
(function (OrderDiscountStatusEnum) {
    OrderDiscountStatusEnum[OrderDiscountStatusEnum["Unknown"] = 0] = "Unknown";
    OrderDiscountStatusEnum[OrderDiscountStatusEnum["Created"] = 1] = "Created";
    OrderDiscountStatusEnum[OrderDiscountStatusEnum["Canceled"] = 10] = "Canceled";
    OrderDiscountStatusEnum[OrderDiscountStatusEnum["Confirmed"] = 20] = "Confirmed";
})(OrderDiscountStatusEnum = exports.OrderDiscountStatusEnum || (exports.OrderDiscountStatusEnum = {}));
var OrderPaymentStatusEnum;
(function (OrderPaymentStatusEnum) {
    OrderPaymentStatusEnum[OrderPaymentStatusEnum["Unknown"] = 0] = "Unknown";
    OrderPaymentStatusEnum[OrderPaymentStatusEnum["PrePending"] = 19] = "PrePending";
    OrderPaymentStatusEnum[OrderPaymentStatusEnum["Pending"] = 20] = "Pending";
    OrderPaymentStatusEnum[OrderPaymentStatusEnum["WaitingForCapture"] = 30] = "WaitingForCapture";
    OrderPaymentStatusEnum[OrderPaymentStatusEnum["Succeeded"] = 40] = "Succeeded";
    OrderPaymentStatusEnum[OrderPaymentStatusEnum["Canceled"] = 50] = "Canceled";
})(OrderPaymentStatusEnum = exports.OrderPaymentStatusEnum || (exports.OrderPaymentStatusEnum = {}));
var OrderPaymentTypeEnum;
(function (OrderPaymentTypeEnum) {
    OrderPaymentTypeEnum[OrderPaymentTypeEnum["Unknown"] = 0] = "Unknown";
    OrderPaymentTypeEnum[OrderPaymentTypeEnum["Online"] = 1] = "Online";
})(OrderPaymentTypeEnum = exports.OrderPaymentTypeEnum || (exports.OrderPaymentTypeEnum = {}));
var OrderStatusEnum;
(function (OrderStatusEnum) {
    OrderStatusEnum[OrderStatusEnum["Unknown"] = 0] = "Unknown";
    OrderStatusEnum[OrderStatusEnum["Created"] = 10] = "Created";
    OrderStatusEnum[OrderStatusEnum["Confirming"] = 20] = "Confirming";
    OrderStatusEnum[OrderStatusEnum["NeedPay"] = 21] = "NeedPay";
    OrderStatusEnum[OrderStatusEnum["NeedCollect"] = 31] = "NeedCollect";
    OrderStatusEnum[OrderStatusEnum["Collecting"] = 40] = "Collecting";
    OrderStatusEnum[OrderStatusEnum["Collected"] = 50] = "Collected";
    OrderStatusEnum[OrderStatusEnum["InDelivery"] = 60] = "InDelivery";
    OrderStatusEnum[OrderStatusEnum["IssuedToCustomer"] = 70] = "IssuedToCustomer";
    OrderStatusEnum[OrderStatusEnum["Payed"] = 90] = "Payed";
    OrderStatusEnum[OrderStatusEnum["Done"] = 100] = "Done";
    OrderStatusEnum[OrderStatusEnum["CanceledByManager"] = 200] = "CanceledByManager";
    OrderStatusEnum[OrderStatusEnum["CanceledByCustomer"] = 201] = "CanceledByCustomer";
    OrderStatusEnum[OrderStatusEnum["CanceledViaChangeByMasterSystem"] = 210] = "CanceledViaChangeByMasterSystem";
    OrderStatusEnum[OrderStatusEnum["RejectedByMasterSystem"] = 211] = "RejectedByMasterSystem";
})(OrderStatusEnum = exports.OrderStatusEnum || (exports.OrderStatusEnum = {}));
var ProductAttributeTypeEnum;
(function (ProductAttributeTypeEnum) {
    ProductAttributeTypeEnum[ProductAttributeTypeEnum["Unknown"] = 0] = "Unknown";
    ProductAttributeTypeEnum[ProductAttributeTypeEnum["Bool"] = 1] = "Bool";
    ProductAttributeTypeEnum[ProductAttributeTypeEnum["Numeral"] = 2] = "Numeral";
    ProductAttributeTypeEnum[ProductAttributeTypeEnum["NumeralRange"] = 3] = "NumeralRange";
    ProductAttributeTypeEnum[ProductAttributeTypeEnum["Decimal"] = 4] = "Decimal";
    ProductAttributeTypeEnum[ProductAttributeTypeEnum["String"] = 5] = "String";
})(ProductAttributeTypeEnum = exports.ProductAttributeTypeEnum || (exports.ProductAttributeTypeEnum = {}));
var PromoTypeEnum;
(function (PromoTypeEnum) {
    PromoTypeEnum[PromoTypeEnum["Unknown"] = 0] = "Unknown";
    PromoTypeEnum[PromoTypeEnum["Absolute"] = 1] = "Absolute";
    PromoTypeEnum[PromoTypeEnum["Relative"] = 2] = "Relative";
})(PromoTypeEnum = exports.PromoTypeEnum || (exports.PromoTypeEnum = {}));
var TradeAgentSignEnum;
(function (TradeAgentSignEnum) {
    TradeAgentSignEnum[TradeAgentSignEnum["None"] = 0] = "None";
    TradeAgentSignEnum[TradeAgentSignEnum["Comissioner"] = 1] = "Comissioner";
})(TradeAgentSignEnum = exports.TradeAgentSignEnum || (exports.TradeAgentSignEnum = {}));
var VATCodeEnum;
(function (VATCodeEnum) {
    VATCodeEnum[VATCodeEnum["Unknown"] = 0] = "Unknown";
    VATCodeEnum[VATCodeEnum["NoVat"] = 1] = "NoVat";
    VATCodeEnum[VATCodeEnum["Vat0"] = 2] = "Vat0";
    VATCodeEnum[VATCodeEnum["Vat10"] = 3] = "Vat10";
    VATCodeEnum[VATCodeEnum["Vat20"] = 4] = "Vat20";
    VATCodeEnum[VATCodeEnum["Vat110"] = 5] = "Vat110";
    VATCodeEnum[VATCodeEnum["Vat120"] = 6] = "Vat120";
    VATCodeEnum[VATCodeEnum["Vat5"] = 7] = "Vat5";
    VATCodeEnum[VATCodeEnum["Vat7"] = 8] = "Vat7";
    VATCodeEnum[VATCodeEnum["Vat105"] = 9] = "Vat105";
    VATCodeEnum[VATCodeEnum["Vat107"] = 10] = "Vat107";
})(VATCodeEnum = exports.VATCodeEnum || (exports.VATCodeEnum = {}));
class Access extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Access");
        this.type = net.def.argEnum("type", initObj, AccessTypeEnum);
        this.data = net.def.argString("data", initObj);
        this.untilTime = net.def.argDate("untilTime", initObj);
    }
}
exports.Access = Access;
class ArticleInfo extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ArticleInfo");
        this.id = net.def.argInt("id", initObj);
        this.alias = net.def.argString("alias", initObj);
        this.type = net.def.argEnum("type", initObj, ArticleTypeEnum);
        this.metaKeywords = net.def.argString("metaKeywords", initObj);
        this.metaDescription = net.def.argString("metaDescription", initObj);
        this.title = net.def.argString("title", initObj);
        this.tag = net.def.argString("tag", initObj);
        this.descriptionShort = net.def.argString("descriptionShort", initObj);
        this.foto = new FileRecord(net.def.argSearch("foto", initObj));
        this.contentMD = net.def.argString("contentMD", initObj);
        this.expectReadTimeMinutes = net.def.argInt("expectReadTimeMinutes", initObj);
        this.showedCount = net.def.argInt("showedCount", initObj);
        this.isPublished = net.def.argBool("isPublished", initObj);
        this.isArchived = net.def.argBool("isArchived", initObj);
        this.published = net.def.argDate("published", initObj);
        this.created = net.def.argDate("created", initObj);
    }
}
exports.ArticleInfo = ArticleInfo;
class ArticleNews extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ArticleNews");
        this.id = net.def.argInt("id", initObj);
        this.alias = net.def.argString("alias", initObj);
        this.type = net.def.argEnum("type", initObj, ArticleTypeEnum);
        this.metaKeywords = net.def.argString("metaKeywords", initObj);
        this.metaDescription = net.def.argString("metaDescription", initObj);
        this.title = net.def.argString("title", initObj);
        this.descriptionShort = net.def.argString("descriptionShort", initObj);
        this.foto = new FileRecord(net.def.argSearch("foto", initObj));
        this.contentMD = net.def.argString("contentMD", initObj);
        this.expectReadTimeMinutes = net.def.argInt("expectReadTimeMinutes", initObj);
        this.showedCount = net.def.argInt("showedCount", initObj);
        this.isPublished = net.def.argBool("isPublished", initObj);
        this.isArchived = net.def.argBool("isArchived", initObj);
        this.published = net.def.argDate("published", initObj);
        this.created = net.def.argDate("created", initObj);
    }
}
exports.ArticleNews = ArticleNews;
class ArticleSale extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ArticleSale");
        this.id = net.def.argInt("id", initObj);
        this.alias = net.def.argString("alias", initObj);
        this.type = net.def.argEnum("type", initObj, ArticleTypeEnum);
        this.metaKeywords = net.def.argString("metaKeywords", initObj);
        this.metaDescription = net.def.argString("metaDescription", initObj);
        this.title = net.def.argString("title", initObj);
        this.descriptionShort = net.def.argString("descriptionShort", initObj);
        this.foto = new FileRecord(net.def.argSearch("foto", initObj));
        this.discountTag = net.def.argString("discountTag", initObj);
        this.discountCategoryId = net.def.argInt("discountCategoryId", initObj);
        this.discountProductIds = net.def.argSearch("discountProductIds", initObj);
        if (!this.discountProductIds)
            this.discountProductIds = [];
        this.contentMD = net.def.argString("contentMD", initObj);
        this.expectReadTimeMinutes = net.def.argInt("expectReadTimeMinutes", initObj);
        this.showedCount = net.def.argInt("showedCount", initObj);
        this.isPublished = net.def.argBool("isPublished", initObj);
        this.isArchived = net.def.argBool("isArchived", initObj);
        this.published = net.def.argDate("published", initObj);
        this.endTime = net.def.argDate("endTime", initObj, null);
        this.created = net.def.argDate("created", initObj);
    }
}
exports.ArticleSale = ArticleSale;
class ArticlesService_Archive_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ArticlesService_Archive_Request");
        this.articleId = net.def.argInt("articleId", initObj);
    }
}
exports.ArticlesService_Archive_Request = ArticlesService_Archive_Request;
class ArticlesService_SetPublished_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ArticlesService_SetPublished_Request");
        this.articleId = net.def.argInt("articleId", initObj);
        this.isPublished = net.def.argBool("isPublished", initObj);
    }
}
exports.ArticlesService_SetPublished_Request = ArticlesService_SetPublished_Request;
class ArticlesService_UpdateInfo_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ArticlesService_UpdateInfo_Request");
        this.article = new ArticleInfo(net.def.argSearch("article", initObj));
    }
}
exports.ArticlesService_UpdateInfo_Request = ArticlesService_UpdateInfo_Request;
class ArticlesService_UpdateNews_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ArticlesService_UpdateNews_Request");
        this.article = new ArticleNews(net.def.argSearch("article", initObj));
    }
}
exports.ArticlesService_UpdateNews_Request = ArticlesService_UpdateNews_Request;
class ArticlesService_UpdateSale_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ArticlesService_UpdateSale_Request");
        this.article = new ArticleSale(net.def.argSearch("article", initObj));
    }
}
exports.ArticlesService_UpdateSale_Request = ArticlesService_UpdateSale_Request;
class ArticlesStatus extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ArticlesStatus");
        this.newsCount = net.def.argInt("newsCount", initObj);
        this.infoCount = net.def.argInt("infoCount", initObj);
        this.saleCount = net.def.argInt("saleCount", initObj);
    }
}
exports.ArticlesStatus = ArticlesStatus;
class AuthService_CheckAuthOrEmpty_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("AuthService_CheckAuthOrEmpty_Request");
        this.withRefresh = net.def.argBool("withRefresh", initObj);
    }
}
exports.AuthService_CheckAuthOrEmpty_Request = AuthService_CheckAuthOrEmpty_Request;
class AuthService_ConfirmAuthCode_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("AuthService_ConfirmAuthCode_Request");
        this.code = net.def.argString("code", initObj);
    }
}
exports.AuthService_ConfirmAuthCode_Request = AuthService_ConfirmAuthCode_Request;
class AuthService_TryAuthByPhone_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("AuthService_TryAuthByPhone_Request");
        this.phone = net.def.argString("phone", initObj);
    }
}
exports.AuthService_TryAuthByPhone_Request = AuthService_TryAuthByPhone_Request;
class AuthService_TryChangePhone_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("AuthService_TryChangePhone_Request");
        this.phone = net.def.argString("phone", initObj);
    }
}
exports.AuthService_TryChangePhone_Request = AuthService_TryChangePhone_Request;
class Authenticator extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Authenticator");
        this.authType = net.def.argEnum("authType", initObj, AuthTypeEnum);
        this.data = net.def.argString("data", initObj);
        this.confirmed = net.def.argBool("confirmed", initObj);
    }
}
exports.Authenticator = Authenticator;
class Brand extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Brand");
        this.extId = net.def.argString("extId", initObj);
        this.id = net.def.argInt("id", initObj);
        this.name = net.def.argString("name", initObj);
        this.logoFile = new FileRecord(net.def.argSearch("logoFile", initObj));
        this.updateTimestamp = net.def.argInt("updateTimestamp", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
    }
}
exports.Brand = Brand;
class BrandExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("BrandExt");
        this.id = net.def.argString("id", initObj);
        this.name = net.def.argString("name", initObj);
        this.logo = new FileRecordExt(net.def.argSearch("logo", initObj));
        this.isDeleted = net.def.argBool("isDeleted", initObj);
    }
}
exports.BrandExt = BrandExt;
class BusinessService_AwaitOrderConfirmMasterSystemLP_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("BusinessService_AwaitOrderConfirmMasterSystemLP_Request");
        this.orderId = net.def.argInt("orderId", initObj);
    }
}
exports.BusinessService_AwaitOrderConfirmMasterSystemLP_Request = BusinessService_AwaitOrderConfirmMasterSystemLP_Request;
class BusinessService_AwaitOrderPaymentPendingLP_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("BusinessService_AwaitOrderPaymentPendingLP_Request");
        this.orderId = net.def.argInt("orderId", initObj);
    }
}
exports.BusinessService_AwaitOrderPaymentPendingLP_Request = BusinessService_AwaitOrderPaymentPendingLP_Request;
class BusinessService_CancelOrderByCustomer_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("BusinessService_CancelOrderByCustomer_Request");
        this.orderId = net.def.argInt("orderId", initObj);
    }
}
exports.BusinessService_CancelOrderByCustomer_Request = BusinessService_CancelOrderByCustomer_Request;
class BusinessService_CreateOrder_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("BusinessService_CreateOrder_Request");
        this.invoice = new OrderInvoice(net.def.argSearch("invoice", initObj));
    }
}
exports.BusinessService_CreateOrder_Request = BusinessService_CreateOrder_Request;
class BusinessService_FilterInStock_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("BusinessService_FilterInStock_Request");
        this.productsIds = net.def.argSearch("productsIds", initObj);
        if (!this.productsIds)
            this.productsIds = [];
    }
}
exports.BusinessService_FilterInStock_Request = BusinessService_FilterInStock_Request;
class BusinessService_QueryOrdersExternal_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("BusinessService_QueryOrdersExternal_Request");
        this.ordersIds = net.def.argSearch("ordersIds", initObj);
        if (!this.ordersIds)
            this.ordersIds = [];
    }
}
exports.BusinessService_QueryOrdersExternal_Request = BusinessService_QueryOrdersExternal_Request;
class BusinessService_UpdateAllRemainders_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("BusinessService_UpdateAllRemainders_Request");
        this.pack = new UpdateRemaindersPackExt(net.def.argSearch("pack", initObj));
    }
}
exports.BusinessService_UpdateAllRemainders_Request = BusinessService_UpdateAllRemainders_Request;
class BusinessService_UpdateOrderProducts_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("BusinessService_UpdateOrderProducts_Request");
        this.order = new OrderUpdateProductsExt(net.def.argSearch("order", initObj));
    }
}
exports.BusinessService_UpdateOrderProducts_Request = BusinessService_UpdateOrderProducts_Request;
class BusinessService_UpdateOrderStatusToIssuedToCustomer_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("BusinessService_UpdateOrderStatusToIssuedToCustomer_Request");
        this.orderStatus = new OrderUpdateStatusExt(net.def.argSearch("orderStatus", initObj));
    }
}
exports.BusinessService_UpdateOrderStatusToIssuedToCustomer_Request = BusinessService_UpdateOrderStatusToIssuedToCustomer_Request;
class BusinessService_UpdateOrdersStatus_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("BusinessService_UpdateOrdersStatus_Request");
        this.orders = [];
        const temporders = net.def.argSearch("orders", initObj);
        if (temporders)
            temporders.forEach(obj => this.orders.push(new OrderUpdateStatusExt(obj)));
    }
}
exports.BusinessService_UpdateOrdersStatus_Request = BusinessService_UpdateOrdersStatus_Request;
class Category extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Category");
        this.extId = net.def.argString("extId", initObj);
        this.id = net.def.argInt("id", initObj);
        this.parentId = net.def.argInt("parentId", initObj);
        this.sortIndex = net.def.argInt("sortIndex", initObj);
        this.name = net.def.argString("name", initObj);
        this.iconSVG = net.def.argString("iconSVG", initObj);
        this.updateTimestamp = net.def.argInt("updateTimestamp", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
        this.productsCount = net.def.argInt("productsCount", initObj);
    }
}
exports.Category = Category;
class CategoryExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("CategoryExt");
        this.id = net.def.argString("id", initObj);
        this.parentId = net.def.argString("parentId", initObj);
        this.order = net.def.argInt("order", initObj);
        this.name = net.def.argString("name", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
    }
}
exports.CategoryExt = CategoryExt;
class Complaint extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Complaint");
        this.id = net.def.argInt("id", initObj);
        this.targetId = net.def.argInt("targetId", initObj);
        this.byUserId = net.def.argInt("byUserId", initObj);
        this.type = net.def.argEnum("type", initObj, ComplaintTypeEnum);
        this.text = net.def.argString("text", initObj);
        this.created = net.def.argDate("created", initObj);
    }
}
exports.Complaint = Complaint;
class Connector1CService_QueryOrdersExternal_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Connector1CService_QueryOrdersExternal_Request");
        this.ordersIds = net.def.argSearch("ordersIds", initObj);
        if (!this.ordersIds)
            this.ordersIds = [];
    }
}
exports.Connector1CService_QueryOrdersExternal_Request = Connector1CService_QueryOrdersExternal_Request;
class Connector1CService_UpdateAllRemainders_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Connector1CService_UpdateAllRemainders_Request");
        this.pack = new UpdateRemaindersPackExt(net.def.argSearch("pack", initObj));
    }
}
exports.Connector1CService_UpdateAllRemainders_Request = Connector1CService_UpdateAllRemainders_Request;
class Connector1CService_UpdateDirectory_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Connector1CService_UpdateDirectory_Request");
        this.pack = new UpdateDataPackExt(net.def.argSearch("pack", initObj));
    }
}
exports.Connector1CService_UpdateDirectory_Request = Connector1CService_UpdateDirectory_Request;
class Connector1CService_UpdateOrderProducts_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Connector1CService_UpdateOrderProducts_Request");
        this.order = new OrderUpdateProductsExt(net.def.argSearch("order", initObj));
    }
}
exports.Connector1CService_UpdateOrderProducts_Request = Connector1CService_UpdateOrderProducts_Request;
class Connector1CService_UpdateOrderStatusToIssuedToCustomer_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Connector1CService_UpdateOrderStatusToIssuedToCustomer_Request");
        this.orderStatus = new OrderUpdateStatusExt(net.def.argSearch("orderStatus", initObj));
    }
}
exports.Connector1CService_UpdateOrderStatusToIssuedToCustomer_Request = Connector1CService_UpdateOrderStatusToIssuedToCustomer_Request;
class Connector1CService_UpdateOrdersStatus_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Connector1CService_UpdateOrdersStatus_Request");
        this.orders = [];
        const temporders = net.def.argSearch("orders", initObj);
        if (temporders)
            temporders.forEach(obj => this.orders.push(new OrderUpdateStatusExt(obj)));
    }
}
exports.Connector1CService_UpdateOrdersStatus_Request = Connector1CService_UpdateOrdersStatus_Request;
class Coordinates extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Coordinates");
        this.lng = net.def.argFloat("lng", initObj);
        this.lat = net.def.argFloat("lat", initObj);
    }
}
exports.Coordinates = Coordinates;
class DeliveryInfo extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("DeliveryInfo");
        this.isAvailable = net.def.argBool("isAvailable", initObj);
        this.tariffName = net.def.argString("tariffName", initObj);
        this.zoneName = net.def.argString("zoneName", initObj);
        this.untilWeightKg = net.def.argFloat("untilWeightKg", initObj);
        this.price = net.def.argFloat("price", initObj);
    }
}
exports.DeliveryInfo = DeliveryInfo;
class DeliveryService_SearchDeliveryInfo_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("DeliveryService_SearchDeliveryInfo_Request");
        this.tariffName = net.def.argString("tariffName", initObj);
        this.pin = new Coordinates(net.def.argSearch("pin", initObj));
        this.weight = net.def.argFloat("weight", initObj);
    }
}
exports.DeliveryService_SearchDeliveryInfo_Request = DeliveryService_SearchDeliveryInfo_Request;
class DirectoryService_QueryProductsIdsByCategories_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("DirectoryService_QueryProductsIdsByCategories_Request");
        this.categoriesId = net.def.argSearch("categoriesId", initObj);
        if (!this.categoriesId)
            this.categoriesId = [];
        this.intersectIds = net.def.argSearch("intersectIds", initObj);
        if (!this.intersectIds)
            this.intersectIds = [];
        this.withUnpublished = net.def.argBool("withUnpublished", initObj);
    }
}
exports.DirectoryService_QueryProductsIdsByCategories_Request = DirectoryService_QueryProductsIdsByCategories_Request;
class DirectoryService_QueryProducts_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("DirectoryService_QueryProducts_Request");
        this.productIds = net.def.argSearch("productIds", initObj);
        if (!this.productIds)
            this.productIds = [];
    }
}
exports.DirectoryService_QueryProducts_Request = DirectoryService_QueryProducts_Request;
class DirectoryService_SortProductsIdsByPrice_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("DirectoryService_SortProductsIdsByPrice_Request");
        this.productIds = net.def.argSearch("productIds", initObj);
        if (!this.productIds)
            this.productIds = [];
        this.desc = net.def.argBool("desc", initObj);
    }
}
exports.DirectoryService_SortProductsIdsByPrice_Request = DirectoryService_SortProductsIdsByPrice_Request;
class DirectoryService_UpdateDirectory_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("DirectoryService_UpdateDirectory_Request");
        this.pack = new UpdateDataPackExt(net.def.argSearch("pack", initObj));
    }
}
exports.DirectoryService_UpdateDirectory_Request = DirectoryService_UpdateDirectory_Request;
class FavoriteService_SetFavoriteProduct_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("FavoriteService_SetFavoriteProduct_Request");
        this.productId = net.def.argInt("productId", initObj);
    }
}
exports.FavoriteService_SetFavoriteProduct_Request = FavoriteService_SetFavoriteProduct_Request;
class FavoriteService_SubsetFavoriteProductsFromList_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("FavoriteService_SubsetFavoriteProductsFromList_Request");
        this.userId = net.def.argInt("userId", initObj);
        this.checkProductIds = net.def.argSearch("checkProductIds", initObj);
        if (!this.checkProductIds)
            this.checkProductIds = [];
    }
}
exports.FavoriteService_SubsetFavoriteProductsFromList_Request = FavoriteService_SubsetFavoriteProductsFromList_Request;
class FavoriteService_UnsetFavoriteProduct_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("FavoriteService_UnsetFavoriteProduct_Request");
        this.productId = net.def.argInt("productId", initObj);
    }
}
exports.FavoriteService_UnsetFavoriteProduct_Request = FavoriteService_UnsetFavoriteProduct_Request;
class FeedPackage extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("FeedPackage");
        this.id = net.def.argInt("id", initObj);
        this.sourceId = net.def.argInt("sourceId", initObj);
        this.sourceType = net.def.argString("sourceType", initObj);
        this.keywords = net.def.argSearch("keywords", initObj);
        if (!this.keywords)
            this.keywords = [];
        this.timestamp = net.def.argInt("timestamp", initObj);
    }
}
exports.FeedPackage = FeedPackage;
class FileDescriptor extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("FileDescriptor");
        this.id = net.def.argString("id", initObj);
        this.hash = net.def.argString("hash", initObj);
        this.category = net.def.argString("category", initObj);
        this.type = net.def.argEnum("type", initObj, FileTypeEnum);
        this.mime = net.def.argString("mime", initObj);
        this.created = net.def.argDate("created", initObj);
        this.attributes = net.def.argString("attributes", initObj);
    }
}
exports.FileDescriptor = FileDescriptor;
class FileRecord extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("FileRecord");
        this.extId = net.def.argString("extId", initObj);
        this.id = net.def.argString("id", initObj);
        this.category = net.def.argString("category", initObj);
        this.tag = net.def.argString("tag", initObj);
        this.format = net.def.argString("format", initObj);
    }
}
exports.FileRecord = FileRecord;
class FileRecordExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("FileRecordExt");
        this.id = net.def.argString("id", initObj);
        this.tag = net.def.argString("tag", initObj);
    }
}
exports.FileRecordExt = FileRecordExt;
class FileUploadReserve extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("FileUploadReserve");
        this.reserveId = net.def.argInt("reserveId", initObj);
        this.tokenId = net.def.argString("tokenId", initObj);
        this.category = net.def.argString("category", initObj);
        this.fileId = net.def.argString("fileId", initObj);
    }
}
exports.FileUploadReserve = FileUploadReserve;
class FilesDirectoryService_QueryReservedFile_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("FilesDirectoryService_QueryReservedFile_Request");
        this.reserveIds = net.def.argSearch("reserveIds", initObj);
        if (!this.reserveIds)
            this.reserveIds = [];
    }
}
exports.FilesDirectoryService_QueryReservedFile_Request = FilesDirectoryService_QueryReservedFile_Request;
class FilesDirectoryService_ReserveUploadFiles_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("FilesDirectoryService_ReserveUploadFiles_Request");
        this.reserves = [];
        const tempreserves = net.def.argSearch("reserves", initObj);
        if (tempreserves)
            tempreserves.forEach(obj => this.reserves.push(new FileUploadReserve(obj)));
    }
}
exports.FilesDirectoryService_ReserveUploadFiles_Request = FilesDirectoryService_ReserveUploadFiles_Request;
class HeadHuntService_PostWorkOfferResponse_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("HeadHuntService_PostWorkOfferResponse_Request");
        this.response = new WorkOfferResponse(net.def.argSearch("response", initObj));
    }
}
exports.HeadHuntService_PostWorkOfferResponse_Request = HeadHuntService_PostWorkOfferResponse_Request;
class HeadHuntService_ProcessWorkOfferResponse_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("HeadHuntService_ProcessWorkOfferResponse_Request");
        this.responseId = net.def.argInt("responseId", initObj);
    }
}
exports.HeadHuntService_ProcessWorkOfferResponse_Request = HeadHuntService_ProcessWorkOfferResponse_Request;
class HeadHuntService_SetPublished_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("HeadHuntService_SetPublished_Request");
        this.offerId = net.def.argInt("offerId", initObj);
        this.isPublished = net.def.argBool("isPublished", initObj);
    }
}
exports.HeadHuntService_SetPublished_Request = HeadHuntService_SetPublished_Request;
class HeadHuntService_UpdateWorkOffer_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("HeadHuntService_UpdateWorkOffer_Request");
        this.offer = new WorkOffer(net.def.argSearch("offer", initObj));
    }
}
exports.HeadHuntService_UpdateWorkOffer_Request = HeadHuntService_UpdateWorkOffer_Request;
class KeywordPair extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("KeywordPair");
        this.source = net.def.argString("source", initObj);
        this.target = net.def.argString("target", initObj);
    }
}
exports.KeywordPair = KeywordPair;
class LoyaltyService_AchivePromoCompany_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("LoyaltyService_AchivePromoCompany_Request");
        this.companyId = net.def.argInt("companyId", initObj);
    }
}
exports.LoyaltyService_AchivePromoCompany_Request = LoyaltyService_AchivePromoCompany_Request;
class LoyaltyService_CreatePromoCompany_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("LoyaltyService_CreatePromoCompany_Request");
        this.company = new PromoCompany(net.def.argSearch("company", initObj));
    }
}
exports.LoyaltyService_CreatePromoCompany_Request = LoyaltyService_CreatePromoCompany_Request;
class LoyaltyService_ProcessOrderDiscount_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("LoyaltyService_ProcessOrderDiscount_Request");
        this.orderDiscount = net.def.argInt("orderDiscount", initObj);
        this.isConfirmed = net.def.argBool("isConfirmed", initObj);
    }
}
exports.LoyaltyService_ProcessOrderDiscount_Request = LoyaltyService_ProcessOrderDiscount_Request;
class LoyaltyService_RequestOrderDiscount_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("LoyaltyService_RequestOrderDiscount_Request");
        this.discountRequest = new OrderDiscountRequest(net.def.argSearch("discountRequest", initObj));
    }
}
exports.LoyaltyService_RequestOrderDiscount_Request = LoyaltyService_RequestOrderDiscount_Request;
class LoyaltyService_SetPromoCompanyActive_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("LoyaltyService_SetPromoCompanyActive_Request");
        this.companyId = net.def.argInt("companyId", initObj);
        this.isActive = net.def.argBool("isActive", initObj);
    }
}
exports.LoyaltyService_SetPromoCompanyActive_Request = LoyaltyService_SetPromoCompanyActive_Request;
class Message extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Message");
        this.id = net.def.argInt("id", initObj);
        this.replyToId = net.def.argInt("replyToId", initObj);
        this.ownerId = net.def.argInt("ownerId", initObj);
        this.ownerName = net.def.argString("ownerName", initObj);
        this.productId = net.def.argInt("productId", initObj);
        this.text = net.def.argString("text", initObj);
        this.likesCount = net.def.argInt("likesCount", initObj);
        this.dislikesCount = net.def.argInt("dislikesCount", initObj);
        this.created = net.def.argDate("created", initObj);
    }
}
exports.Message = Message;
class NBResult extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("NBResult");
        this.status = net.def.argInt("status", initObj);
        this.code = net.def.argInt("code", initObj);
        this.message = net.def.argString("message", initObj);
        this.description = net.def.argString("description", initObj);
    }
}
exports.NBResult = NBResult;
class OkResult extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OkResult");
        this.statusCode = net.def.argInt("statusCode", initObj);
    }
}
exports.OkResult = OkResult;
class Order extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Order");
        this.id = net.def.argInt("id", initObj);
        this.forwardFromId = net.def.argInt("forwardFromId", initObj);
        this.extId = net.def.argString("extId", initObj);
        this.status = net.def.argEnum("status", initObj, OrderStatusEnum);
        this.discounts = net.def.argSearch("discounts", initObj);
        if (!this.discounts)
            this.discounts = [];
        this.products = [];
        const tempproducts = net.def.argSearch("products", initObj);
        if (tempproducts)
            tempproducts.forEach(obj => this.products.push(new OrderProduct(obj)));
        this.totalCost = net.def.argFloat("totalCost", initObj);
        this.created = net.def.argDate("created", initObj);
        this.updated = net.def.argDate("updated", initObj);
        this.paymentInfo = new OrderPayment(net.def.argSearch("paymentInfo", initObj));
        this.delivery = new OrderDelivery(net.def.argSearch("delivery", initObj));
        this.customerId = net.def.argInt("customerId", initObj);
        this.customer = new OrderCustomer(net.def.argSearch("customer", initObj));
        this.comment = net.def.argString("comment", initObj);
        this.isPayed = net.def.argBool("isPayed", initObj);
        this.paymentStatus = net.def.argEnum("paymentStatus", initObj, OrderPaymentStatusEnum);
        this.statusInternal = net.def.argEnum("statusInternal", initObj, OrderStatusEnum);
        this.isClosed = net.def.argBool("isClosed", initObj);
        this.isNeedUpdateForMasterSystem = net.def.argBool("isNeedUpdateForMasterSystem", initObj);
    }
}
exports.Order = Order;
class OrderCustomer extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderCustomer");
        this.id = net.def.argInt("id", initObj);
        this.phone = net.def.argString("phone", initObj);
        this.email = net.def.argString("email", initObj);
        this.name = net.def.argString("name", initObj);
        this.photoFile = net.def.argString("photoFile", initObj);
        this.birthDay = net.def.argDate("birthDay", initObj, null);
    }
}
exports.OrderCustomer = OrderCustomer;
class OrderCustomerExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderCustomerExt");
        this.id = net.def.argInt("id", initObj);
        this.phone = net.def.argString("phone", initObj);
        this.email = net.def.argString("email", initObj);
        this.name = net.def.argString("name", initObj);
        this.photoFile = net.def.argString("photoFile", initObj);
        this.birthDay = net.def.argDate("birthDay", initObj, null);
    }
}
exports.OrderCustomerExt = OrderCustomerExt;
class OrderDelivery extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderDelivery");
        this.type = net.def.argEnum("type", initObj, OrderDeliveryTypeEnum);
        this.price = net.def.argFloat("price", initObj);
        this.pin = new Coordinates(net.def.argSearch("pin", initObj));
        this.address = net.def.argString("address", initObj);
        this.deliveryInfo = new DeliveryInfo(net.def.argSearch("deliveryInfo", initObj));
    }
}
exports.OrderDelivery = OrderDelivery;
class OrderDeliveryExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderDeliveryExt");
        this.type = net.def.argEnum("type", initObj, OrderDeliveryTypeEnum);
        this.price = net.def.argFloat("price", initObj);
        this.pin = new Coordinates(net.def.argSearch("pin", initObj));
        this.address = net.def.argString("address", initObj);
        this.deliveryInfo = new DeliveryInfo(net.def.argSearch("deliveryInfo", initObj));
    }
}
exports.OrderDeliveryExt = OrderDeliveryExt;
class OrderDiscount extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderDiscount");
        this.id = net.def.argInt("id", initObj);
        this.orderId = net.def.argString("orderId", initObj);
        this.status = net.def.argEnum("status", initObj, OrderDiscountStatusEnum);
        this.promoCompanyId = net.def.argInt("promoCompanyId", initObj);
        this.initCost = net.def.argFloat("initCost", initObj);
        this.discount = net.def.argFloat("discount", initObj);
        this.products = [];
        const tempproducts = net.def.argSearch("products", initObj);
        if (tempproducts)
            tempproducts.forEach(obj => this.products.push(new ProductDiscount(obj)));
        this.created = net.def.argDate("created", initObj);
    }
}
exports.OrderDiscount = OrderDiscount;
class OrderDiscountRequest extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderDiscountRequest");
        this.orderId = net.def.argString("orderId", initObj);
        this.promoCode = net.def.argString("promoCode", initObj);
        this.initCost = net.def.argFloat("initCost", initObj);
        this.products = [];
        const tempproducts = net.def.argSearch("products", initObj);
        if (tempproducts)
            tempproducts.forEach(obj => this.products.push(new ProductDiscount(obj)));
    }
}
exports.OrderDiscountRequest = OrderDiscountRequest;
class OrderExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderExt");
        this.siteId = net.def.argInt("siteId", initObj);
        this.forwardFromSiteId = net.def.argInt("forwardFromSiteId", initObj);
        this.id = net.def.argString("id", initObj);
        this.status = net.def.argEnum("status", initObj, OrderStatusEnum);
        this.discounts = net.def.argSearch("discounts", initObj);
        if (!this.discounts)
            this.discounts = [];
        this.products = [];
        const tempproducts = net.def.argSearch("products", initObj);
        if (tempproducts)
            tempproducts.forEach(obj => this.products.push(new OrderProductExt(obj)));
        this.totalCost = net.def.argFloat("totalCost", initObj);
        this.createdUnixTimestampMS = net.def.argInt("createdUnixTimestampMS", initObj);
        this.updatedUnixTimestampMS = net.def.argInt("updatedUnixTimestampMS", initObj);
        this.delivery = new OrderDeliveryExt(net.def.argSearch("delivery", initObj));
        this.customerId = net.def.argInt("customerId", initObj);
        this.customer = new OrderCustomerExt(net.def.argSearch("customer", initObj));
        this.comment = net.def.argString("comment", initObj);
        this.paymentInfo = new OrderPaymentExt(net.def.argSearch("paymentInfo", initObj));
        this.paymentStatus = net.def.argEnum("paymentStatus", initObj, OrderPaymentStatusEnum);
        this.statusInternal = net.def.argEnum("statusInternal", initObj, OrderStatusEnum);
        this.isPayed = net.def.argBool("isPayed", initObj);
        this.isClosed = net.def.argBool("isClosed", initObj);
    }
}
exports.OrderExt = OrderExt;
class OrderInvoice extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderInvoice");
        this.items = [];
        const tempitems = net.def.argSearch("items", initObj);
        if (tempitems)
            tempitems.forEach(obj => this.items.push(new OrderInvoiceItem(obj)));
        this.discounts = net.def.argSearch("discounts", initObj);
        if (!this.discounts)
            this.discounts = [];
        this.checkCost = net.def.argFloat("checkCost", initObj);
        this.delivery = new OrderDelivery(net.def.argSearch("delivery", initObj));
        this.paymentType = net.def.argEnum("paymentType", initObj, OrderPaymentTypeEnum);
        this.userEmail = net.def.argString("userEmail", initObj);
        this.userName = net.def.argString("userName", initObj);
        this.comment = net.def.argString("comment", initObj);
    }
}
exports.OrderInvoice = OrderInvoice;
class OrderInvoiceItem extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderInvoiceItem");
        this.productId = net.def.argInt("productId", initObj);
        this.amount = net.def.argFloat("amount", initObj);
    }
}
exports.OrderInvoiceItem = OrderInvoiceItem;
class OrderPayment extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderPayment");
        this.type = net.def.argEnum("type", initObj, OrderPaymentTypeEnum);
        this.paymentGate = net.def.argString("paymentGate", initObj);
        this.payment = new OrderPaymentDetails(net.def.argSearch("payment", initObj));
        this.refund = new OrderPaymentDetails(net.def.argSearch("refund", initObj));
    }
}
exports.OrderPayment = OrderPayment;
class OrderPaymentDetails extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderPaymentDetails");
        this.amount = net.def.argFloat("amount", initObj);
        this.paymentInternalId = net.def.argString("paymentInternalId", initObj);
        this.paymentId = net.def.argString("paymentId", initObj);
        this.paymentURL = net.def.argString("paymentURL", initObj);
        this.status = net.def.argString("status", initObj);
    }
}
exports.OrderPaymentDetails = OrderPaymentDetails;
class OrderPaymentDetailsExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderPaymentDetailsExt");
        this.amount = net.def.argFloat("amount", initObj);
        this.paymentInternalId = net.def.argString("paymentInternalId", initObj);
        this.paymentId = net.def.argString("paymentId", initObj);
        this.status = net.def.argString("status", initObj);
    }
}
exports.OrderPaymentDetailsExt = OrderPaymentDetailsExt;
class OrderPaymentExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderPaymentExt");
        this.type = net.def.argEnum("type", initObj, OrderPaymentTypeEnum);
        this.paymentGate = net.def.argString("paymentGate", initObj);
        this.payment = new OrderPaymentDetailsExt(net.def.argSearch("payment", initObj));
        this.refund = new OrderPaymentDetailsExt(net.def.argSearch("refund", initObj));
    }
}
exports.OrderPaymentExt = OrderPaymentExt;
class OrderProduct extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderProduct");
        this.id = net.def.argInt("id", initObj);
        this.extId = net.def.argString("extId", initObj);
        this.name = net.def.argString("name", initObj);
        this.count = net.def.argFloat("count", initObj);
        this.countInit = net.def.argFloat("countInit", initObj);
        this.costPerOne = net.def.argFloat("costPerOne", initObj);
        this.costWithDiscountPerOne = net.def.argFloat("costWithDiscountPerOne", initObj);
        this.totalPrice = net.def.argFloat("totalPrice", initObj);
        this.vat = net.def.argEnum("vat", initObj, VATCodeEnum);
        this.tradeAgentSign = net.def.argEnum("tradeAgentSign", initObj, TradeAgentSignEnum);
        this.tradeAgent = new TradeAgent(net.def.argSearch("tradeAgent", initObj));
    }
}
exports.OrderProduct = OrderProduct;
class OrderProductExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderProductExt");
        this.id = net.def.argString("id", initObj);
        this.name = net.def.argString("name", initObj);
        this.count = net.def.argFloat("count", initObj);
        this.countInit = net.def.argFloat("countInit", initObj);
        this.costPerOne = net.def.argFloat("costPerOne", initObj);
        this.costWithDiscountPerOne = net.def.argFloat("costWithDiscountPerOne", initObj);
        this.totalPrice = net.def.argFloat("totalPrice", initObj);
    }
}
exports.OrderProductExt = OrderProductExt;
class OrderUpdateProductsExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderUpdateProductsExt");
        this.siteId = net.def.argInt("siteId", initObj);
        this.products = [];
        const tempproducts = net.def.argSearch("products", initObj);
        if (tempproducts)
            tempproducts.forEach(obj => this.products.push(new OrderProductExt(obj)));
        this.totalCost = net.def.argFloat("totalCost", initObj);
    }
}
exports.OrderUpdateProductsExt = OrderUpdateProductsExt;
class OrderUpdateStatusExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrderUpdateStatusExt");
        this.siteId = net.def.argInt("siteId", initObj);
        this.id = net.def.argString("id", initObj);
        this.status = net.def.argEnum("status", initObj, OrderStatusEnum);
    }
}
exports.OrderUpdateStatusExt = OrderUpdateStatusExt;
class OrdersPairExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("OrdersPairExt");
        this.orderOld = new OrderExt(net.def.argSearch("orderOld", initObj));
        this.orderNew = new OrderExt(net.def.argSearch("orderNew", initObj));
    }
}
exports.OrdersPairExt = OrdersPairExt;
class Product extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Product");
        this.extId = net.def.argString("extId", initObj);
        this.id = net.def.argInt("id", initObj);
        this.categoryId = net.def.argInt("categoryId", initObj);
        this.article = net.def.argString("article", initObj);
        this.name = net.def.argString("name", initObj);
        this.nameSEO = net.def.argString("nameSEO", initObj);
        this.description = net.def.argString("description", initObj);
        this.descriptionSEO = net.def.argString("descriptionSEO", initObj);
        this.barCodes = net.def.argSearch("barCodes", initObj);
        if (!this.barCodes)
            this.barCodes = [];
        this.unitCode = net.def.argInt("unitCode", initObj);
        this.brandId = net.def.argInt("brandId", initObj);
        this.fotos = [];
        const tempfotos = net.def.argSearch("fotos", initObj);
        if (tempfotos)
            tempfotos.forEach(obj => this.fotos.push(new FileRecord(obj)));
        this.files = [];
        const tempfiles = net.def.argSearch("files", initObj);
        if (tempfiles)
            tempfiles.forEach(obj => this.files.push(new FileRecord(obj)));
        this.price = net.def.argFloat("price", initObj);
        this.weightKg = net.def.argFloat("weightKg", initObj);
        this.sizeM = new Volume(net.def.argSearch("sizeM", initObj));
        this.volumeM = net.def.argFloat("volumeM", initObj);
        this.vatCode = net.def.argEnum("vatCode", initObj, VATCodeEnum);
        this.tradeAgentSign = net.def.argEnum("tradeAgentSign", initObj, TradeAgentSignEnum);
        this.tradeAgent = new TradeAgent(net.def.argSearch("tradeAgent", initObj));
        this.isPublished = net.def.argBool("isPublished", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
        this.updateTimestamp = net.def.argInt("updateTimestamp", initObj);
        this.brand = new Brand(net.def.argSearch("brand", initObj));
        this.attributes = [];
        const tempattributes = net.def.argSearch("attributes", initObj);
        if (tempattributes)
            tempattributes.forEach(obj => this.attributes.push(new ProductAttribute(obj)));
        this.rate = net.def.argFloat("rate", initObj);
        this.remainder = net.def.argFloat("remainder", initObj);
    }
}
exports.Product = Product;
class ProductAttribute extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProductAttribute");
        this.productId = net.def.argInt("productId", initObj);
        this.attributeTypeId = net.def.argInt("attributeTypeId", initObj);
        this.value = net.def.argString("value", initObj);
        this.updateTimestamp = net.def.argInt("updateTimestamp", initObj);
        this.type = new ProductAttributeType(net.def.argSearch("type", initObj));
    }
}
exports.ProductAttribute = ProductAttribute;
class ProductAttributeExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProductAttributeExt");
        this.productId = net.def.argString("productId", initObj);
        this.attributeTypeId = net.def.argString("attributeTypeId", initObj);
        this.value = net.def.argString("value", initObj);
    }
}
exports.ProductAttributeExt = ProductAttributeExt;
class ProductAttributeType extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProductAttributeType");
        this.extId = net.def.argString("extId", initObj);
        this.id = net.def.argInt("id", initObj);
        this.categoryId = net.def.argInt("categoryId", initObj);
        this.typeEnum = net.def.argEnum("typeEnum", initObj, ProductAttributeTypeEnum);
        this.name = net.def.argString("name", initObj);
        this.sortIndex = net.def.argInt("sortIndex", initObj);
        this.updateTimestamp = net.def.argInt("updateTimestamp", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
    }
}
exports.ProductAttributeType = ProductAttributeType;
class ProductAttributeTypeExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProductAttributeTypeExt");
        this.id = net.def.argString("id", initObj);
        this.categoryId = net.def.argString("categoryId", initObj);
        this.typeEnum = net.def.argEnum("typeEnum", initObj, ProductAttributeTypeEnum);
        this.name = net.def.argString("name", initObj);
        this.order = net.def.argInt("order", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
    }
}
exports.ProductAttributeTypeExt = ProductAttributeTypeExt;
class ProductDiscount extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProductDiscount");
        this.productId = net.def.argInt("productId", initObj);
        this.count = net.def.argFloat("count", initObj);
        this.costPerOne = net.def.argFloat("costPerOne", initObj);
        this.costWithDiscountPerOne = net.def.argFloat("costWithDiscountPerOne", initObj);
    }
}
exports.ProductDiscount = ProductDiscount;
class ProductExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProductExt");
        this.id = net.def.argString("id", initObj);
        this.extCode = net.def.argString("extCode", initObj);
        this.category = net.def.argString("category", initObj);
        this.article = net.def.argString("article", initObj);
        this.name = net.def.argString("name", initObj);
        this.nameSEO = net.def.argString("nameSEO", initObj);
        this.description = net.def.argString("description", initObj);
        this.descriptionSEO = net.def.argString("descriptionSEO", initObj);
        this.barCodes = net.def.argSearch("barCodes", initObj);
        if (!this.barCodes)
            this.barCodes = [];
        this.unitCode = net.def.argInt("unitCode", initObj);
        this.brandId = net.def.argString("brandId", initObj);
        this.fotos = [];
        const tempfotos = net.def.argSearch("fotos", initObj);
        if (tempfotos)
            tempfotos.forEach(obj => this.fotos.push(new FileRecordExt(obj)));
        this.files = [];
        const tempfiles = net.def.argSearch("files", initObj);
        if (tempfiles)
            tempfiles.forEach(obj => this.files.push(new FileRecordExt(obj)));
        this.price = net.def.argFloat("price", initObj);
        this.weightKg = net.def.argFloat("weightKg", initObj);
        this.sizeM = new Volume(net.def.argSearch("sizeM", initObj));
        this.volumeM = net.def.argFloat("volumeM", initObj);
        this.vatCode = net.def.argEnum("vatCode", initObj, VATCodeEnum);
        this.tradeAgentSign = net.def.argEnum("tradeAgentSign", initObj, TradeAgentSignEnum);
        this.tradeAgent = new TradeAgent(net.def.argSearch("tradeAgent", initObj));
        this.isPublished = net.def.argBool("isPublished", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
    }
}
exports.ProductExt = ProductExt;
class ProductReport extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProductReport");
        this.productId = net.def.argInt("productId", initObj);
        this.rateMiddle = net.def.argFloat("rateMiddle", initObj);
        this.reviewsCount = net.def.argInt("reviewsCount", initObj);
        this.reviewsAllFotos = net.def.argSearch("reviewsAllFotos", initObj);
        if (!this.reviewsAllFotos)
            this.reviewsAllFotos = [];
        this.bestReview = new Review(net.def.argSearch("bestReview", initObj));
        this.lastReviews = [];
        const templastReviews = net.def.argSearch("lastReviews", initObj);
        if (templastReviews)
            templastReviews.forEach(obj => this.lastReviews.push(new Review(obj)));
        this.questionsCount = net.def.argInt("questionsCount", initObj);
        this.lastQuestionsWithReply = [];
        const templastQuestionsWithReply = net.def.argSearch("lastQuestionsWithReply", initObj);
        if (templastQuestionsWithReply)
            templastQuestionsWithReply.forEach(obj => this.lastQuestionsWithReply.push(new Message(obj)));
    }
}
exports.ProductReport = ProductReport;
class ProfilesService_ChangeUserEmail_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProfilesService_ChangeUserEmail_Request");
        this.userId = net.def.argInt("userId", initObj);
        this.email = net.def.argString("email", initObj);
    }
}
exports.ProfilesService_ChangeUserEmail_Request = ProfilesService_ChangeUserEmail_Request;
class ProfilesService_ChangeUserPhone_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProfilesService_ChangeUserPhone_Request");
        this.userId = net.def.argInt("userId", initObj);
        this.phone = net.def.argString("phone", initObj);
    }
}
exports.ProfilesService_ChangeUserPhone_Request = ProfilesService_ChangeUserPhone_Request;
class ProfilesService_CreateUserByPhone_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProfilesService_CreateUserByPhone_Request");
        this.phone = net.def.argString("phone", initObj);
    }
}
exports.ProfilesService_CreateUserByPhone_Request = ProfilesService_CreateUserByPhone_Request;
class ProfilesService_DeleteUser_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProfilesService_DeleteUser_Request");
        this.userId = net.def.argInt("userId", initObj);
    }
}
exports.ProfilesService_DeleteUser_Request = ProfilesService_DeleteUser_Request;
class ProfilesService_SearchUsersByAccesses_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProfilesService_SearchUsersByAccesses_Request");
        this.include = net.def.argSearch("include", initObj);
        if (!this.include)
            this.include = [];
        this.exclude = net.def.argSearch("exclude", initObj);
        if (!this.exclude)
            this.exclude = [];
        this.includeWithNoAccess = net.def.argBool("includeWithNoAccess", initObj);
    }
}
exports.ProfilesService_SearchUsersByAccesses_Request = ProfilesService_SearchUsersByAccesses_Request;
class ProfilesService_SearchUsers_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProfilesService_SearchUsers_Request");
        this.dataParted = net.def.argString("dataParted", initObj);
    }
}
exports.ProfilesService_SearchUsers_Request = ProfilesService_SearchUsers_Request;
class ProfilesService_SetUserAccess_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProfilesService_SetUserAccess_Request");
        this.userId = net.def.argInt("userId", initObj);
        this.access = new Access(net.def.argSearch("access", initObj));
    }
}
exports.ProfilesService_SetUserAccess_Request = ProfilesService_SetUserAccess_Request;
class ProfilesService_SetUserAllAccesses_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProfilesService_SetUserAllAccesses_Request");
        this.userId = net.def.argInt("userId", initObj);
        this.accesses = [];
        const tempaccesses = net.def.argSearch("accesses", initObj);
        if (tempaccesses)
            tempaccesses.forEach(obj => this.accesses.push(new Access(obj)));
    }
}
exports.ProfilesService_SetUserAllAccesses_Request = ProfilesService_SetUserAllAccesses_Request;
class ProfilesService_SetUserData_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProfilesService_SetUserData_Request");
        this.user = new User(net.def.argSearch("user", initObj));
    }
}
exports.ProfilesService_SetUserData_Request = ProfilesService_SetUserData_Request;
class ProfilesService_UnsetUserAccess_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ProfilesService_UnsetUserAccess_Request");
        this.userId = net.def.argInt("userId", initObj);
        this.accessType = net.def.argInt("accessType", initObj);
    }
}
exports.ProfilesService_UnsetUserAccess_Request = ProfilesService_UnsetUserAccess_Request;
class PromoCompany extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("PromoCompany");
        this.id = net.def.argInt("id", initObj);
        this.isActive = net.def.argBool("isActive", initObj);
        this.isArchived = net.def.argBool("isArchived", initObj);
        this.promoType = net.def.argEnum("promoType", initObj, PromoTypeEnum);
        this.promoCode = net.def.argString("promoCode", initObj);
        this.categoryId = net.def.argInt("categoryId", initObj);
        this.categoryName = net.def.argString("categoryName", initObj);
        this.productIds = net.def.argSearch("productIds", initObj);
        if (!this.productIds)
            this.productIds = [];
        this.discountRelativeIndex = net.def.argFloat("discountRelativeIndex", initObj);
        this.discountRelativeMaxSize = net.def.argFloat("discountRelativeMaxSize", initObj);
        this.discountAbsoluteAmount = net.def.argFloat("discountAbsoluteAmount", initObj);
        this.discountFromSum = net.def.argFloat("discountFromSum", initObj);
        this.countOfCodes = net.def.argInt("countOfCodes", initObj);
        this.currentCountOfCodes = net.def.argInt("currentCountOfCodes", initObj);
        this.startDate = net.def.argDate("startDate", initObj, null);
        this.endDate = net.def.argDate("endDate", initObj, null);
    }
}
exports.PromoCompany = PromoCompany;
class QueryFilter extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("QueryFilter");
        this.filterTypeId = net.def.argInt("filterTypeId", initObj);
        this.values = net.def.argSearch("values", initObj);
        if (!this.values)
            this.values = [];
    }
}
exports.QueryFilter = QueryFilter;
class RemainderExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("RemainderExt");
        this.productId = net.def.argString("productId", initObj);
        this.value = net.def.argFloat("value", initObj);
    }
}
exports.RemainderExt = RemainderExt;
class ResultPack1C extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ResultPack1C");
        this.status = net.def.argInt("status", initObj);
        this.packId = net.def.argInt("packId", initObj);
    }
}
exports.ResultPack1C = ResultPack1C;
class Review extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Review");
        this.id = net.def.argInt("id", initObj);
        this.ownerId = net.def.argInt("ownerId", initObj);
        this.ownerName = net.def.argString("ownerName", initObj);
        this.productId = net.def.argInt("productId", initObj);
        this.rate = net.def.argInt("rate", initObj);
        this.text = net.def.argString("text", initObj);
        this.fotos = net.def.argSearch("fotos", initObj);
        if (!this.fotos)
            this.fotos = [];
        this.likesCount = net.def.argInt("likesCount", initObj);
        this.dislikesCount = net.def.argInt("dislikesCount", initObj);
        this.created = net.def.argDate("created", initObj);
    }
}
exports.Review = Review;
class ReviewsService_Complaint_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ReviewsService_Complaint_Request");
        this.complaint = new Complaint(net.def.argSearch("complaint", initObj));
    }
}
exports.ReviewsService_Complaint_Request = ReviewsService_Complaint_Request;
class ReviewsService_DeleteMessage_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ReviewsService_DeleteMessage_Request");
        this.messageId = net.def.argInt("messageId", initObj);
    }
}
exports.ReviewsService_DeleteMessage_Request = ReviewsService_DeleteMessage_Request;
class ReviewsService_DeleteReview_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ReviewsService_DeleteReview_Request");
        this.reviewId = net.def.argInt("reviewId", initObj);
    }
}
exports.ReviewsService_DeleteReview_Request = ReviewsService_DeleteReview_Request;
class ReviewsService_PostMessage_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ReviewsService_PostMessage_Request");
        this.message = new Message(net.def.argSearch("message", initObj));
    }
}
exports.ReviewsService_PostMessage_Request = ReviewsService_PostMessage_Request;
class ReviewsService_PostReview_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ReviewsService_PostReview_Request");
        this.review = new Review(net.def.argSearch("review", initObj));
    }
}
exports.ReviewsService_PostReview_Request = ReviewsService_PostReview_Request;
class ReviewsService_ProcessComplaint_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ReviewsService_ProcessComplaint_Request");
        this.complaintId = net.def.argInt("complaintId", initObj);
        this.ignoreComplaint = net.def.argBool("ignoreComplaint", initObj);
    }
}
exports.ReviewsService_ProcessComplaint_Request = ReviewsService_ProcessComplaint_Request;
class ReviewsService_ReactOnMessage_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ReviewsService_ReactOnMessage_Request");
        this.messageId = net.def.argInt("messageId", initObj);
        this.isLike = net.def.argBool("isLike", initObj);
    }
}
exports.ReviewsService_ReactOnMessage_Request = ReviewsService_ReactOnMessage_Request;
class ReviewsService_ReactOnReview_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("ReviewsService_ReactOnReview_Request");
        this.reviewId = net.def.argInt("reviewId", initObj);
        this.isLike = net.def.argBool("isLike", initObj);
    }
}
exports.ReviewsService_ReactOnReview_Request = ReviewsService_ReactOnReview_Request;
class SearchService_Feed_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("SearchService_Feed_Request");
        this.feeds = [];
        const tempfeeds = net.def.argSearch("feeds", initObj);
        if (tempfeeds)
            tempfeeds.forEach(obj => this.feeds.push(new FeedPackage(obj)));
    }
}
exports.SearchService_Feed_Request = SearchService_Feed_Request;
class SearchService_SearchProductsIds_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("SearchService_SearchProductsIds_Request");
        this.query = net.def.argString("query", initObj);
        this.filters = [];
        const tempfilters = net.def.argSearch("filters", initObj);
        if (tempfilters)
            tempfilters.forEach(obj => this.filters.push(new QueryFilter(obj)));
        this.sortType = net.def.argInt("sortType", initObj);
    }
}
exports.SearchService_SearchProductsIds_Request = SearchService_SearchProductsIds_Request;
class SearchService_SetMisspellings_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("SearchService_SetMisspellings_Request");
        this.pairs = [];
        const temppairs = net.def.argSearch("pairs", initObj);
        if (temppairs)
            temppairs.forEach(obj => this.pairs.push(new KeywordPair(obj)));
    }
}
exports.SearchService_SetMisspellings_Request = SearchService_SetMisspellings_Request;
class SearchService_SetSynonyms_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("SearchService_SetSynonyms_Request");
        this.pairs = [];
        const temppairs = net.def.argSearch("pairs", initObj);
        if (temppairs)
            temppairs.forEach(obj => this.pairs.push(new KeywordPair(obj)));
    }
}
exports.SearchService_SetSynonyms_Request = SearchService_SetSynonyms_Request;
class SearchService_SetTypos_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("SearchService_SetTypos_Request");
        this.pairs = [];
        const temppairs = net.def.argSearch("pairs", initObj);
        if (temppairs)
            temppairs.forEach(obj => this.pairs.push(new KeywordPair(obj)));
    }
}
exports.SearchService_SetTypos_Request = SearchService_SetTypos_Request;
class SupportRequest extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("SupportRequest");
        this.id = net.def.argInt("id", initObj);
        this.fromUserId = net.def.argInt("fromUserId", initObj);
        this.reason = net.def.argString("reason", initObj);
        this.subReason = net.def.argString("subReason", initObj);
        this.city = net.def.argString("city", initObj);
        this.message = net.def.argString("message", initObj);
        this.userName = net.def.argString("userName", initObj);
        this.userEmail = net.def.argString("userEmail", initObj);
        this.userPhone = net.def.argString("userPhone", initObj);
        this.fotos = net.def.argSearch("fotos", initObj);
        if (!this.fotos)
            this.fotos = [];
        this.isClosed = net.def.argBool("isClosed", initObj);
        this.created = net.def.argDate("created", initObj);
        this.closed = net.def.argDate("closed", initObj);
    }
}
exports.SupportRequest = SupportRequest;
class SupportService_CloseRequest_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("SupportService_CloseRequest_Request");
        this.requestId = net.def.argInt("requestId", initObj);
    }
}
exports.SupportService_CloseRequest_Request = SupportService_CloseRequest_Request;
class SupportService_CreateRequest_Request extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("SupportService_CreateRequest_Request");
        this.request = new SupportRequest(net.def.argSearch("request", initObj));
    }
}
exports.SupportService_CreateRequest_Request = SupportService_CreateRequest_Request;
class Tariff extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Tariff");
        this.name = net.def.argString("name", initObj);
        this.net = [];
        const tempnet = net.def.argSearch("net", initObj);
        if (tempnet)
            tempnet.forEach(obj => this.net.push(new TariffNet(obj)));
    }
}
exports.Tariff = Tariff;
class TariffNet extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("TariffNet");
        this.zoneName = net.def.argString("zoneName", initObj);
        this.untilWeightKg = net.def.argFloat("untilWeightKg", initObj);
        this.price = net.def.argFloat("price", initObj);
    }
}
exports.TariffNet = TariffNet;
class TariffZone extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("TariffZone");
        this.name = net.def.argString("name", initObj);
        this.coordinates = [];
        const tempcoordinates = net.def.argSearch("coordinates", initObj);
        if (tempcoordinates)
            tempcoordinates.forEach(obj => this.coordinates.push(new Coordinates(obj)));
    }
}
exports.TariffZone = TariffZone;
class TariffsBook extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("TariffsBook");
        this.tariffs = [];
        const temptariffs = net.def.argSearch("tariffs", initObj);
        if (temptariffs)
            temptariffs.forEach(obj => this.tariffs.push(new Tariff(obj)));
        this.zones = [];
        const tempzones = net.def.argSearch("zones", initObj);
        if (tempzones)
            tempzones.forEach(obj => this.zones.push(new TariffZone(obj)));
    }
}
exports.TariffsBook = TariffsBook;
class TradeAgent extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("TradeAgent");
        this.orgName = net.def.argString("orgName", initObj);
        this.tin = net.def.argString("tin", initObj);
        this.phone = net.def.argString("phone", initObj);
    }
}
exports.TradeAgent = TradeAgent;
class UpdateDataPackExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("UpdateDataPackExt");
        this.packId = net.def.argInt("packId", initObj);
        this.brands = [];
        const tempbrands = net.def.argSearch("brands", initObj);
        if (tempbrands)
            tempbrands.forEach(obj => this.brands.push(new BrandExt(obj)));
        this.categories = [];
        const tempcategories = net.def.argSearch("categories", initObj);
        if (tempcategories)
            tempcategories.forEach(obj => this.categories.push(new CategoryExt(obj)));
        this.productAttributeTypes = [];
        const tempproductAttributeTypes = net.def.argSearch("productAttributeTypes", initObj);
        if (tempproductAttributeTypes)
            tempproductAttributeTypes.forEach(obj => this.productAttributeTypes.push(new ProductAttributeTypeExt(obj)));
        this.products = [];
        const tempproducts = net.def.argSearch("products", initObj);
        if (tempproducts)
            tempproducts.forEach(obj => this.products.push(new ProductExt(obj)));
        this.productAttributes = [];
        const tempproductAttributes = net.def.argSearch("productAttributes", initObj);
        if (tempproductAttributes)
            tempproductAttributes.forEach(obj => this.productAttributes.push(new ProductAttributeExt(obj)));
    }
}
exports.UpdateDataPackExt = UpdateDataPackExt;
class UpdateRemaindersPackExt extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("UpdateRemaindersPackExt");
        this.packId = net.def.argInt("packId", initObj);
        this.remainders = [];
        const tempremainders = net.def.argSearch("remainders", initObj);
        if (tempremainders)
            tempremainders.forEach(obj => this.remainders.push(new RemainderExt(obj)));
    }
}
exports.UpdateRemaindersPackExt = UpdateRemaindersPackExt;
class User extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("User");
        this.id = net.def.argInt("id", initObj);
        this.created = net.def.argDate("created", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
        this.name = net.def.argString("name", initObj);
        this.photoFile = net.def.argString("photoFile", initObj);
        this.birthDay = net.def.argDate("birthDay", initObj, null);
        this.auths = [];
        const tempauths = net.def.argSearch("auths", initObj);
        if (tempauths)
            tempauths.forEach(obj => this.auths.push(new Authenticator(obj)));
        this.accesses = [];
        const tempaccesses = net.def.argSearch("accesses", initObj);
        if (tempaccesses)
            tempaccesses.forEach(obj => this.accesses.push(new Access(obj)));
    }
}
exports.User = User;
class Volume extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("Volume");
        this.width = net.def.argFloat("width", initObj);
        this.length = net.def.argFloat("length", initObj);
        this.height = net.def.argFloat("height", initObj);
    }
}
exports.Volume = Volume;
class WorkOffer extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("WorkOffer");
        this.id = net.def.argInt("id", initObj);
        this.header = net.def.argString("header", initObj);
        this.city = net.def.argString("city", initObj);
        this.subHeaderInfo = net.def.argString("subHeaderInfo", initObj);
        this.employmentType = net.def.argString("employmentType", initObj);
        this.schedule = net.def.argString("schedule", initObj);
        this.experience = net.def.argString("experience", initObj);
        this.salary = net.def.argString("salary", initObj);
        this.descriptionMD = net.def.argString("descriptionMD", initObj);
        this.contactsMD = net.def.argString("contactsMD", initObj);
        this.tags = net.def.argSearch("tags", initObj);
        if (!this.tags)
            this.tags = [];
        this.isPublished = net.def.argBool("isPublished", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
        this.created = net.def.argDate("created", initObj);
    }
}
exports.WorkOffer = WorkOffer;
class WorkOfferResponse extends net.Model {
    /**
    * @param {object} initObj -
    */
    constructor(initObj = {}) {
        super("WorkOfferResponse");
        this.id = net.def.argInt("id", initObj);
        this.offerId = net.def.argInt("offerId", initObj);
        this.name = net.def.argString("name", initObj);
        this.surname = net.def.argString("surname", initObj);
        this.phone = net.def.argString("phone", initObj);
        this.comment = net.def.argString("comment", initObj);
        this.hhLink = net.def.argString("hhLink", initObj);
        this.isProcessed = net.def.argBool("isProcessed", initObj);
        this.created = net.def.argDate("created", initObj);
    }
}
exports.WorkOfferResponse = WorkOfferResponse;
//# sourceMappingURL=models.js.map